import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project import
import config from 'config';
import useAuth from 'hooks/useAuth';
import { GuardProps } from 'types/auth';

import { config as conf } from '../../env';
const ENV_NAME = conf.env_name;

// types

// ==============================|| GUEST GUARD ||============================== //

const GuestGuard = ({ children }: GuardProps) => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const localMaintenance = localStorage.getItem('CURRENT_MAINTENANCE_' + ENV_NAME);
    if (localMaintenance && localMaintenance.toUpperCase() === 'TRUE') {
      console.log('Redirecting to maintenance');
      navigate('maintenance', { replace: true });
      return;
    }
    if (isAuthenticated) {
      navigate(config.pricing, { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return children;
};

export default GuestGuard;
